export default "__VITE_ASSET__DBHac8yZ__"